import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { requireTab } from "@/features/navigation/requireTab";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sales")({
    component: () => <Outlet />,
    beforeLoad: async ({ context }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        await requireTab(context, "sales");

        return context;
    },
});
